import { connect, ConnectedProps } from 'react-redux';

import { FormLoginSamlEmailData } from 'dashboard/forms/FormLoginSamlEmail/FormLoginSamlEmail';
import SessionClientOnboard from 'dashboard/lib/clients/SessionClientOnboard';
import useRedirectIfLoggedIn from 'dashboard/lib/hooks/useRedirectIfLoggedIn';
import { clearMessages, showMessage } from 'dashboard/redux/actions/messages';
import DashboardLoginSamlEmailView from 'dashboard/views/DashboardLoginSamlEmailView';
import useApiCallback from 'lib/hooks/useApiCallback';
import useApiErrorHandler from 'lib/hooks/useApiErrorHandler';
import { ApiEndpoint } from 'lib/interfaces/api';

const DashboardLoginSamlEmailRoute = (props: PropsFromRedux) => {
  useRedirectIfLoggedIn();

  const { callback: login, error } = useApiCallback(
    async ({ emailAddress }: FormLoginSamlEmailData) => {
      props.clearMessages();

      const { 'sso-url': ssoUrl } = await SessionClientOnboard.getEndpoint<any>(
        ApiEndpoint.OrganizationsSSO,
        { headers: { 'Persona-User-Email-Address': emailAddress } },
      );

      if (ssoUrl == null) {
        props.showMessage('This organization is not configured for SSO');
      } else {
        // This is an external URL so we don't use history.push
        window.location.assign(ssoUrl);
      }
    },
    [],
  );

  useApiErrorHandler({
    error,
    onNetworkError: () =>
      props.showMessage('Sorry, something went wrong. Please try again later or contact support.'),
    onError: () =>
      props.showMessage('Failed to login. Please check your email address and try again.'),
  });

  return <DashboardLoginSamlEmailView login={login} />;
};

const mapDispatchToProps = {
  clearMessages,
  showMessage,
};

const connector = connect(null, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardLoginSamlEmailRoute);
